<template>
  <div class="box-content max-w-[240px] p-4 text-md">
    <span v-if="title" class="mb-2 block text-md font-bold text-gray-700">
      {{ title }}
    </span>
    <span
      v-if="description"
      class="text-md font-normal text-gray-500"
      v-text="description"
    />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  title: string
  description: string
}>()
</script>
